import React from "react";

export const TikTok = () => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z"
        fill="white"
      />
      <path
        d="M23.3823 12H20.6859V22.8985C20.6859 24.1971 19.6488 25.2638 18.3582 25.2638C17.0675 25.2638 16.0304 24.1971 16.0304 22.8985C16.0304 21.6232 17.0445 20.5797 18.289 20.5333V17.7971C15.5465 17.8435 13.334 20.0928 13.334 22.8985C13.334 25.7276 15.5926 28 18.3812 28C21.1698 28 23.4284 25.7044 23.4284 22.8985V17.3101C24.4425 18.0522 25.687 18.4928 27.0007 18.516V15.7797C24.9726 15.7101 23.3823 14.0406 23.3823 12Z"
        fill="#6C3BC7"
        fillOpacity="0.8"
      />
    </svg>
  );
};
